export * from './IconAlignRight';
